import React from 'react';

import { VerdeLogo } from '../../Atoms';

export default function AcChargers() {
  return (
    <>
      <section className='blade-margin-top-sm '>
        <section className="relative overflow-hidden">
          <section className=" max-w-xl lg:max-w-7xl mx-auto w-11/12 px-2 md:px-4">
            <h3 className="text-center font-gilroy">
            Charger Hassle-Free
            </h3>
          </section>
        </section>
      </section>
    </>
  );
}
